<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">累计在线用户信息</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="终端名称" prop="Terminal">
            <el-input v-model="Terminal" placeholder="请输入终端名称"></el-input>
          </el-form-item>
          <el-form-item label="IP地址" prop="IpAddr">
            <el-input v-model="IpAddr" placeholder="请输入IP地址"></el-input>
          </el-form-item>
          <el-form-item label="Wlan" prop="Wlan">
            <el-input v-model="Wlan" placeholder="请输入Wlan"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="连接时间" prop="date">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width:60rem;"
                  unlink-panels
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="UserName" label="终端名称"></el-table-column>
              <el-table-column prop="TerminalType" label="终端类型"></el-table-column>
              <el-table-column prop="IP" label="IP地址" :formatter="formatIP"></el-table-column>
              <el-table-column prop="Wlan" label="Wlan"></el-table-column>
               <el-table-column prop="Extend1" label="是否在线"></el-table-column>
              <el-table-column prop="CreateTime" label="连接时间" width="140" :formatter="formatDate"></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "WifiRealtimeVisitorListView",
  controller: "UI",
  action: "WifiRealtimeVisitorListView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Terminal: "",
      IpAddr: "",
      Wlan: "",
      date: [new Date(), new Date()]
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        UserName: this.Terminal,
        IP: this.IpAddr,
        Wlan: this.Wlan,
        CreateStartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        CreateEndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.TranResourcesApi()
        .GetRealtimeVisitorList(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.Terminal = "";
      this.IpAddr = "";
      this.Wlan = "";
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    //IP展示格式
    formatIP(row, column) {
      // 获取单元格数据
      let IP = row[column.property];
      if (IP != null && IP.indexOf("<br") > 0) {
        return IP.substring(0, IP.indexOf("<br"));
      }
      return IP;
    }
  }
};
</script>
